import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { statusDescription } from 'src/app/data/utils/arrival/monitoring-message.utils';
import { SimpleLogEntry } from './model/simple-log-entry';

@Component({
  templateUrl: './simple-log-sheet.component.html',
  styleUrls: ['./simple-log-sheet.component.scss'],
})
export class SimpleLogSheetComponent {

  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: SimpleLogEntry[]) {
  }

  description(dataMsg: SimpleLogEntry, index: number) {
    return index === 0 ? statusDescription(dataMsg.status, dataMsg.message) : statusDescription(dataMsg.status, dataMsg.message, dataMsg.status)
  }
}
